import React from 'react';
import PropTypes from 'prop-types';
import { useSpring, animated } from '@react-spring/web';
import { ReactSVG } from 'react-svg';
import { Textfit } from 'react-textfit';
import crowd from '../../assets/crowd.svg';
import '../Slides.scss'
import './ConcertAttendanceSlide.scss';

const ConcertAttendanceSlide = ({ data }) => {

  const {
   concerts_count,
   kid_name
  } = data;

  const titleSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 200, friction: 25 },
    delay: 400,
  });

  const subTitleSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 200, friction: 25 },
    delay: 600,
  });

  const crowdSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(100vh)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    delay: 800,
  });

  const concertCountSpring = useSpring({
    from: { opacity: 0, transform: 'scale(2)' },
    to: { opacity: 1, transform: 'scale(1)' },
    config: { tension: 280, friction: 20 },
    delay: 1200,
  });

  const concertCountWrapperSpring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    delay: 1000,
  })

  const textSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    config: { tension: 200, friction: 25 },
    delay: 1000,
  });

  return (
    <div className='Slide__concert_attendance'>
      <animated.h2 className='Slide__concert_attendance__title' style={titleSpring}>Concerts!</animated.h2>
      <animated.h3 className='Slide__concert_attendance__subTitle' style={subTitleSpring}>{concerts_count && concerts_count >= 1 ? 'Total number of concerts' : 'Working towards their...'}</animated.h3>
      <animated.div
        className='Slide__concert_attendance__count'
        style={{
          ...concertCountWrapperSpring,
          padding: concerts_count >= 1 ? '20px 60px' : '20px 30px 60px'
        }}
      >
        {concerts_count >= 1 ? (
          <animated.p style={concertCountSpring} className='Slide__concert_attendance__count__number'>{concerts_count}</animated.p>
        ) : (
          <animated.p style={concertCountSpring} className='Slide__concert_attendance__count__1'>
            1
            <span className='Slide__concert_attendance__count__end'>st</span>
          </animated.p>
        )}
        {concerts_count < 1 && <p className='Slide__concert_attendance__count__word'>concert</p>}
      </animated.div>
      <animated.div className='Slide__concert_attendance__crowd' style={crowdSpring}>
        <ReactSVG src={crowd} />
      </animated.div>
      <animated.div
        className='Slide__concert_attendance__bottomLine'
        style={{
          ...textSpring,
          marginTop: concerts_count && concerts_count > 1 ? '-40px' : '0px'
        }}
      >
        <p>Keep on Rockin’,</p>
        <Textfit mode="single" max={32} style={{ maxWidth: '200px' }}>{kid_name}</Textfit>
      </animated.div>
    </div>
  )
}

export default ConcertAttendanceSlide;

const DataProps = {
  concerts_count: PropTypes.number,
  kid_name: PropTypes.string.isRequired
}

ConcertAttendanceSlide.propTypes = {
  data: PropTypes.shape(DataProps).isRequired
}
